import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=0cf547ae&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"
import style0 from "./Step3.vue?vue&type=style&index=0&id=0cf547ae&prod&scoped=true&lang=scss"
import style1 from "./Step3.vue?vue&type=style&index=1&id=0cf547ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf547ae",
  null
  
)

export default component.exports